// TODO Fix types
import produce from 'immer';

import { RootState } from '../redux/reducers';
import { typedAction } from './common/actions';
import Logger from '../../../shared/utils/logger';
import { IPersonalization } from '../../../shared/types/Personalization';
import { Nullable } from '../../../shared/types/Typescript-utils';
import { ISocialFeedsGroupedItem, SocialFeedsTypesMap } from '../../../shared/mappers/map-social-feeds';
import { ITintMeta } from '../../../shared/services/tint.service';
import { TintWrapper } from '../services/tint-wrapper';
import { Dispatch, AnyAction } from 'redux';

export enum TintStatus {
  FETCHING = 'TINT_FETCHING',
  SUCCESS = 'TINT_SUCCESS',
  ERROR = 'TINT_ERROR',
}

export enum CustomFontType {
  CUSTOM_FONT_POPUP = 'CUSTOM_FONT_POPUP',
  CUSTOM_FONT_SECONDARY = 'CUSTOM_FONT_SECONDARY',
}

interface TintState {
  personalization: Nullable<IPersonalization>;
  socialFeeds: Nullable<SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>>;
  meta: Nullable<ITintMeta>;
  error: Nullable<Error>;
  status: Nullable<TintStatus>;
  customFontSecondary?: Nullable<string>;
  customFontPopup?: Nullable<string>;
}

const initialState: TintState = {
  personalization: null,
  socialFeeds: null,
  meta: null,
  error: null,
  status: null,
};

export const FETCHING = 'tint/fetching';
export const FETCHING_SUCCESS = 'tint/success';
export const FETCHING_ERROR = 'tint/error';
export const UPDATE = 'tint/update';
export const UPDATE_PERSONALIZATION = 'tint/update-personalization';
export const UPDATE_CUSTOM_FONT_SECONDARY = 'tint/update-custom-font-secondary';
export const FETCHING_FONT = 'font/fetching';
export const FETCHING_FONT_SUCCESS = 'font/success';
export const FETCHING_FONT_ERROR = 'font/error';

export const fetchCustomFont = (fontId: number, teamId: number, type: string) => {
  return typedAction(FETCHING_FONT, { fontId, teamId, type });
};

export const fetchCustomFontError = () => {
  return typedAction(FETCHING_FONT_ERROR);
};

export const fetchCustomFontSuccess = (payload: {
  customFontSecondary?: Nullable<string>;
  customFontPopup?: Nullable<string>;
}) => {
  return typedAction(FETCHING_FONT_SUCCESS, payload);
};

export const fetchTint = () => {
  return typedAction(FETCHING);
};

export const fetchTintSuccess = (payload: {
  meta: ITintMeta;
  personalization: IPersonalization;
  socialFeeds: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>;
  customFontSecondary?: Nullable<string>;
  customFontPopup?: Nullable<string>;
}) => {
  return typedAction(FETCHING_SUCCESS, payload);
};

export const fetchTintError = (payload: Error) => {
  Logger.warning(payload);
  return typedAction(FETCHING_ERROR, payload);
};

export const updateTint = (payload: {
  personalization?: Nullable<IPersonalization>;
  socialFeeds?: Nullable<SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>>;
  meta?: Nullable<ITintMeta>;
  error?: Nullable<Error>;
  status?: Nullable<TintStatus>;
  customFontSecondary?: Nullable<string>;
  customFontPopup?: Nullable<string>;
}) => {
  return typedAction(UPDATE, payload);
};

export const updateTintPersonalization = (payload: any) => {
  return typedAction(UPDATE_PERSONALIZATION, payload);
};

export const updateCustomFont = (teamId: number, fontId: number, type: CustomFontType) => {
  return (dispatch: Dispatch<AnyAction>) =>
    Promise.resolve().then(() => {
      dispatch(fetchCustomFont(teamId, fontId, type));
      return TintWrapper.getTint()
        .getCustomFont(teamId, fontId)
        .then(res => {
          const data = res.data;
          dispatch(
            fetchCustomFontSuccess({
              ...(type === CustomFontType.CUSTOM_FONT_SECONDARY ? { customFontSecondary: data } : {}),
              ...(type === CustomFontType.CUSTOM_FONT_POPUP ? { customFontPopup: data } : {}),
            })
          );
        })
        .catch(() => dispatch(fetchCustomFontError()));
    });
};

type TintAction = ReturnType<
  | typeof fetchTint
  | typeof fetchTintSuccess
  | typeof fetchTintError
  | typeof updateTint
  | typeof updateTintPersonalization
  | typeof fetchCustomFont
  | typeof fetchCustomFontError
  | typeof fetchCustomFontSuccess
>;

export function tintReducer(state = initialState, action: TintAction): TintState {
  switch (action.type) {
    case FETCHING:
    case FETCHING_FONT:
      return { ...state, status: TintStatus.FETCHING };
    case FETCHING_SUCCESS:
    case FETCHING_FONT_SUCCESS:
      return {
        ...state,
        status: TintStatus.SUCCESS,
        ...action.payload,
      };
    case FETCHING_ERROR:
      return { ...state, status: TintStatus.ERROR, error: action.payload };
    case FETCHING_FONT_ERROR:
      return { ...state, status: TintStatus.SUCCESS };
    case UPDATE:
      return { ...state, ...action.payload };
    case UPDATE_PERSONALIZATION:
      return produce(state, draftState => {
        if (draftState.personalization) {
          //Check new structure and the old one
          if (action.payload.draft) {
            draftState.personalization.attributes.data = {
              ...draftState.personalization.attributes.data,
              ...action.payload.draft,
            };
          } else {
            draftState.personalization.attributes.data = {
              ...draftState.personalization.attributes.data,
              ...action.payload,
            };
          }
        }
      });
    default:
      return state;
  }
}

export const selectTint = (state: RootState) => state.tint;
